import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpcatalog1postPostCatalogDraftsResponseSchema = jsonObject
export type tcpcatalog1postPostCatalogDraftsResponse = z.infer<typeof tcpcatalog1postPostCatalogDraftsResponseSchema>
